// extracted by mini-css-extract-plugin
module.exports = {"flipButton":"ButtonFlip-module__flipButton___XVKxZ","flipIcon":"ButtonFlip-module__flipIcon___2sPKY","flipButtonIcon":"ButtonFlip-module__flipButtonIcon___bfz4J"};